<div class="content">
  <div class="content-panel">
    <h2>Suivi des DR et des DREV</h2>
    <form [formGroup]="searchForm" #form="ngForm" (ngSubmit)="search()">
      <div class="cols">
        <div class="col">
          <div class="row">
            <!-- Année de récolte -->
            <div class="col-md-2">
              <div class="mb-3">
                <label translate>Année de récolte *</label> :
                <input type="text" formControlName="annee" class="form-control" [ngClass]="{'is-invalid': form.submitted && searchForm.get('annee').invalid}" />
              </div>
            </div>

            <!-- Avec DR -->
            <div class="col-md-2">
              <div class="mb-3">
                <label translate>Avec DR</label> :
                <select formControlName="withDR" class="form-select">
                  <option [ngValue]="null">Toutes</option>
                  <option Value="true">Oui</option>
                  <option Value="false">Non</option>
                </select>
              </div>
            </div>

            <!-- Type de DR -->
            <div class="col-md-2">
              <div class="mb-3">
                <label translate>Type de DR</label> :
                <select formControlName="typeDR" class="form-select">
                  <option [ngValue]="null">{{ TypeDr.TOUTES | capitalize }}</option>
                  <option [ngValue]="TypeDr.INITIALE">{{ TypeDr.INITIALE | capitalize }}</option>
                  <option [ngValue]="TypeDr.MODIFIEE">{{ TypeDr.MODIFIEE | capitalize }}</option>
                </select>
              </div>
            </div>

            <!-- Avec DREV -->
            <div class="col-md-2">
              <div class="mb-3">
                <label translate>Avec DREV</label> :
                <select formControlName="withDREV" class="form-select">
                  <option [ngValue]="null">Toutes</option>
                  <option Value="true">Oui</option>
                  <option Value="false">Non</option>
                </select>
              </div>
            </div>

            <!-- Raison sociale -->
            <div class="col-md-2">
              <div class="mb-3">
                <label translate>Raison sociale / CVI</label> :
                <input type="text" formControlName="raisonSociale" class="form-control" />
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Date début de dépôt DR -->
            <div class="col-md-2">
              <div class="mb-3">
                <label for="debutDateDepot" class="col-form-label pt-0"
                       translate>Date de dépôt DR entre</label> :
                <div class="input-group">
                  <input id="debutDateDepot" ngbDatepicker #debutDepotDatepicker="ngbDatepicker"
                         formControlName="dateDebutDepotDR" class="form-control" />
                  <button type="button" (click)="debutDepotDatepicker.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Date fin de dépôt DR -->
            <div class="col-md-2">
              <div class="mb-3">
                <label for="finDateDepot" class="col-form-label pt-0"
                       translate>et</label> :
                <div class="input-group">
                  <input id="finDateDepot" ngbDatepicker #finDepotDatepicker="ngbDatepicker"
                         formControlName="dateFinDepotDR" class="form-control" />
                  <button type="button" (click)="finDepotDatepicker.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Date début de saisie DREV -->
            <div class="col-md-2">
              <div class="mb-3">
                <label for="debutDateSaisie" class="col-form-label pt-0"
                       translate>Date de saisie DREV entre</label> :
                <div class="input-group">
                  <input id="debutDateSaisie" ngbDatepicker #debutSaisieDatepicker="ngbDatepicker"
                         formControlName="dateDebutSaisieDREV" class="form-control" />
                  <button type="button" (click)="debutSaisieDatepicker.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Date fin de saisie DREV -->
            <div class="col-md-2">
              <div class="mb-3">
                <label for="finDateSaisie" class="col-form-label pt-0"
                       translate>et</label> :
                <div class="input-group">
                  <input id="finDateSaisie" ngbDatepicker #finSaisieDatepicker="ngbDatepicker"
                         formControlName="dateFinSaisieDREV" class="form-control" />
                  <button type="button" (click)="finSaisieDatepicker.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Button filtrer -->
            <div class="col-md-2 ml-3 mt-4 pt-1">
              <button type="submit" class="btn btn-primary" translate>label.filtrer</button>
            </div>
          </div>
        </div>
      </div>
    </form>

      <table class="table table-striped" aria-label="Suivi des DR/DREV" *ngIf="suiviDrDrev.length > 0; else aucuneSaisie">
          <thead>
          <tr>
              <th *ngFor="let column of columns">
                  <span translate>{{ column.label }}</span>
              </th>
              <th></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let suivi of suiviDrDrev">
              <td *ngFor="let column of columns" class="column-max-width">
                  <ng-container [ngSwitch]="column.field">
                      <span *ngSwitchCase="'raisonSociale'">{{ suivi.raisonSociale }}</span>
                      <span *ngSwitchCase="'cvi'">{{ suivi.cvi }}</span>
                      <span *ngSwitchCase="'dateDepotDR'">{{ suivi.dateDepotDR | date: 'dd/MM/yyyy' }}</span>
                      <span *ngSwitchCase="'typeDR'">{{ suivi.typeDR }}</span>
                      <span *ngSwitchCase="'superficie'">{{ suivi.superficie | number: '1.3-3' }}</span>
                      <span *ngSwitchCase="'volRevendicableDR'">{{ suivi.volRevendicableDR | number: '1.2-2' }}</span>
                      <span *ngSwitchCase="'dateSaisieDREV'">{{ suivi.dateSaisieDREV | date: 'dd/MM/yyyy' }}</span>
                      <span *ngSwitchCase="'volTotalRevendique'">{{ suivi.volTotalRevendique | number: '1.2-2' }}</span>
                  </ng-container>
              </td>

              <!-- Colonne Actions -->
              <td>
                  <h4 (click)="goToDashboard(suivi.idIntervenant)" (keydown.enter)="goToDashboard(suivi.idIntervenant)">
                      <fa-icon [ngbTooltip]="'Accéder au tableau de bord'" class="clickable-icon btn-primary button-operateur" [icon]="['far','address-card']" style="font-size:20px"></fa-icon>
                  </h4>
              </td>
          </tr>
          </tbody>
      </table>
  </div>
</div>

<!-- Template aucune saisie -->
<ng-template #aucuneSaisie>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon>Aucun résultat pour les critères renseignés.
  </div>
</ng-template>
<!-- Fin template aucune saisie -->
